import { useState,useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import './home.css'
import { Link } from 'react-router-dom';
import Skills from '../skiills/Skills';
import Contact from '../Contact/Contact';
import Footer from '../footer/footer';

const Home = () => { 
  const [text, setText] = useState('');
  const toRotate = ["FrontEnd Developer","Tech Enthusiast & Open source Contributor"]
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period=2000

  useEffect(() => {
    const ticker= setInterval(() => {
      tick()
    }, delta);
    return ()=> (clearInterval(ticker))
  }, [text]);

  const tick=()=>{
    const i= loopNum % toRotate.length
    const fullText=toRotate[i]

    const updatedText= isDeleting ? fullText.substring(0, text.length -1) : fullText.substring(0, text.length +1)
    
    setText(updatedText)
     if (isDeleting) {
    setDelta(prevDelta => prevDelta/2)
  }

  if (!isDeleting && updatedText === fullText) {
    setIsDeleting(true)
    setDelta(period)
  }
  else if (isDeleting && updatedText === '') {
    setIsDeleting(false)
    setDelta(500)
    setLoopNum(loopNum + 1)
  }
  }
  const onButtonClick=()=>{
    fetch('TechResume.pdf')
    .then(res =>{
      res.blob()
      .then(blob=> {
        const fileURL= window.URL.createObjectURL(blob);
        let alink= document.createElement('a')
        alink.href=fileURL
        alink.download='TechResume.pdf'
        alink.click()
      })
    })
  }

  return (
    <div className='general'>
      <div className="home">
        <Container className='p-5'>
          <Row>
            <Col className='text-center align-items-center justify-content-center'>
              <h3 className='main-color mb-3'>Hello, i'm</h3>
              <h2 className='text-white fw-bolder'>Gabriel Femi Igbalaye</h2>
              <p className='text text-white'>i'm a {text}<span className='changeDot'>.</span> </p>
              <p className='lead main-color mb-5'>
                I specialize in buiding scalable web apps and providing
                better experience for users, In other words i code beautifully simple
                things that intrigue the users. and i love what i do
              </p>
              <div className="but gap-3">
                <button onClick={onButtonClick}>Download Resume</button>
                <button> <Link to='/project'>Projects</Link> </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div>
        <Skills/>
      </div>
      <div>
        <Contact/>
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  )
}

export default Home